import eBook_1 from '../assets/eBooks/eBook_1.jpg';
import eBook_2 from '../assets/eBooks/eBook_2.jpg';
import eBook_3 from '../assets/eBooks/eBook_3.jpg';
import eBook_4 from '../assets/eBooks/eBook_4.jpg';
import eBook_5 from '../assets/eBooks/eBook_5.jpg';
import eBook_6 from '../assets/eBooks/eBook_6.jpg';
import eBook_7 from '../assets/eBooks/eBook_7.jpg';
import eBook_8 from '../assets/eBooks/eBook_8.jpg';
import eBook_9 from '../assets/eBooks/eBook_9.jpg';
import eBook_10 from '../assets/eBooks/eBook_10.jpg';
import eBook_11 from '../assets/eBooks/eBook_11.jpg';
import eBook_12 from '../assets/eBooks/eBook_12.jpg';
import eBook_13 from '../assets/eBooks/eBook_13.jpg';
import eBook_14 from '../assets/eBooks/eBook_14.jpg';
import eBook_15 from '../assets/eBooks/eBook_15.jpg';
import eBook_16 from '../assets/eBooks/eBook_16.jpg';

export const eBooksData = [
  {
    author: 'Colleen Hoover',
    title: 'It Starts With Us',
    image: `${eBook_1}`,
  },

  {
    author: 'Lee Child and Andrew Child',
    title: 'No Plan B',
    image: `${eBook_2}`,
  },

  {
    author: 'Jess Lourney',
    title: 'The Quarry Girls',
    image: `${eBook_3}`,
  },

  {
    author: 'John Grisham',
    title: 'Boys From Biloxi',
    image: `${eBook_4}`,
  },

  {
    author: 'Jeneva Rose',
    title: 'The Perfect Marriage',
    image: `${eBook_5}`,
  },

  {
    author: 'Catharina Maura',
    title: 'The Wrong Bride',
    image: `${eBook_6}`,
  },

  {
    author: 'George R. R. Martin',
    title: 'Fire & Blood',
    image: `${eBook_7}`,
  },

  {
    author: 'Freida McFadden',
    title: 'The Housemaid',
    image: `${eBook_8}`,
  },

  {
    author: 'Brittney Sahin',
    title: "Until You Can't",
    image: `${eBook_9}`,
  },

  {
    author: 'Colleen Hoover',
    title: 'Reminders of Him',
    image: `${eBook_10}`,
  },

  {
    author: 'Alice Hoffman',
    title: 'The Bookstore Sisters',
    image: `${eBook_11}`,
  },

  {
    author: 'Jonathan Kellerman',
    title: 'Motive',
    image: `${eBook_12}`,
  },

  {
    author: 'Dean Koontz',
    title: 'The Other Emily',
    image: `${eBook_13}`,
  },

  {
    author: 'Ana Huang',
    title: 'King of Wrath',
    image: `${eBook_14}`,
  },

  {
    author: 'Meghan Quinn',
    title: 'Runaway Groomsman',
    image: `${eBook_15}`,
  },

  {
    author: 'Shain Rose',
    title: 'Corrupted Chaos',
    image: `${eBook_16}`,
  },
];
